module.exports = __webpack_public_path__ + "static/media/augendusche_loesung.8f3a820f.jpg";